import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react'
import Layout from '../../Components/Layout'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import hotelService from '../../services/hotelService';
import { calculateDistance, getSimilarityScore, findHotelsByDistanceAndSimilarity } from '../../services/hotelUtils';
import ListCard from '../../Components/Hotel/ListCard';
import SearchForm from '../../Components/Hotel/SearchForm';
import { Modal, Button } from "react-bootstrap";
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import { FaStar, FaHotel, FaMapMarkerAlt, FaBed } from "react-icons/fa";
import { MdOutlineLocalAirport } from "react-icons/md";
import { GoogleMap, LoadScript, Marker, InfoWindow, useJsApiLoader } from '@react-google-maps/api';
import staticDataService from '../../services/staticDataService';
import GoogleMapsLoader from '../../Components/Autocomplete/GoogleMapsLoader';
import config from '../../config';
import Swal from 'sweetalert2';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import axios from 'axios';
import { FaMapPin } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { FaDotCircle } from "react-icons/fa";
import RateCard from '../../Components/Hotel/RateCard';
import { getPrice } from '../../services/priceUtils';
import ReactDOM from 'react-dom';

export default function GridList2() {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const counterRef = useRef(null);
    const mapRef = useRef(null);
    const { occupancies, start_date, end_date } = location.state || {};

    const [formParams, setFormParams] = useState({
        locationName: searchParams.get('locationName'),
        checkIn: searchParams.get('checkIn'),
        checkOut: searchParams.get('checkOut'),
        nation: searchParams.get('nation'),
        lat: searchParams.get('lat'),
        lng: searchParams.get('lng'),
        occupanciesStr: searchParams.get('occupancies'),
        rooms: (() => {
            try {
                const occupanciesStr = searchParams.get('occupancies');
                if (occupanciesStr) {
                    const decodedStr = decodeURIComponent(occupanciesStr);
                    const parsed = JSON.parse(decodedStr);
                    if (Array.isArray(parsed)) {
                        return parsed.map((room, index) => ({
                            id: index + 1,
                            adultCounter: room.adults || 2,
                            childCounter: room.children || 0,
                            childrenAges: room.paxes?.filter(pax => pax.type === "CH").map(child => ({
                                type: 'CH',
                                age: child.age || 0
                            })) || []
                        }));
                    }
                }
            } catch (error) {
                console.error('Error parsing occupancies:', error);
            }
            return [{
                id: 1,
                adultCounter: 2,
                childCounter: 0,
                childrenAges: []
            }];
        })()
    });

    const [selectedRate, setSelectedRate] = useState(null);
    const [isMapLoaded, setIsMapLoaded] = useState(false);
    
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'script-loader',
        googleMapsApiKey: config.API_KEY,
        libraries: ['places']
    });

    useEffect(() => {
        if (isLoaded && !loadError) {
            setIsMapLoaded(true);
        }
    }, [isLoaded, loadError]);

    const StaticGoogleMap = ({ apiKey, markers }) => {
        if (!isMapLoaded || loadError) return null;

        const baseUrl = "https://maps.googleapis.com/maps/api/staticmap";
        const mapSize = "600x200";
        const zoom = 15;

        const markerParams = markers
            .map(marker => `markers=color:red%7Clabel:%7C${marker.lat},${marker.lng}`)
            .join("&");

        const mapUrl = `${baseUrl}?size=${mapSize}&zoom=${zoom}&${markerParams}&key=${apiKey}`;

        return (
            <div style={{ height: "200px", width: "100%" }}>
                <img src={mapUrl} alt="Static Google Map" style={{ width: "100%", height: "100%", objectFit: 'cover' }} />
            </div>
        );
    };

    const [hotelCodes, setHotelCodes] = useState([]);
    const [sortedHotels, setSortedHotels] = useState([]);
    const [detailedHotels, setDetailedHotels] = useState([]);
    const [firstHotel, setFirstHotel] = useState(null);
    const [loadedHotels, setLoadedHotels] = useState([]);
    const [moreStatu, setMoreStatu] = useState(false);
    const [moreButtonStatu, setMoreButtonStatu] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingHotels, setLoadingHotels] = useState({});
    const [moreCounter, setMoreCounter] = useState(0);
    const step = 10;

    const [markers, setMarkers] = useState([]);

    const [selectedLocation, setSelectedLocation] = useState({
        name: location.state?.selectedLocation?.name ?? null,
        latitude: location.state?.selectedLocation?.latitude ?? null,
        longitude: location.state?.selectedLocation?.longitude ?? null,
        hotelbeds_code: location.state?.selectedLocation?.hotelbeds_code ?? null,
        formatted_address: location.state?.selectedLocation?.formatted_address ?? null,
    });

    const [selectedPlace, setSelectedPlace] = useState({
        name: localStorage.getItem("place_name"),
        lat: localStorage.getItem("lat"),
        lng: localStorage.getItem("lng"),
    });

    const userData = JSON.parse(localStorage.getItem('user_data'));

    const [sortOption, setSortOption] = useState({type:'default', column:'default'});
    const [pagination, setPagination] = useState({
        currentPage: 1,
        hasMore: false,
        totalPages: 0
    });

    const [initialHotels, setInitialHotels] = useState([]);
    const [hotelIds, setHotelIds] = useState([]);
    const [rates, setRates] = useState({
        minRate: 0,
        maxRate: 7500
    });
    const [error, setError] = useState(null);

    const loadSmallData = useCallback(async (code, index) => {
        if (!code || loadingHotels[code]) return;
        
        if (loadedHotels.includes(code)) {
            console.log(`Otel ${code} zaten yüklenmiş, tekrar yükleme yapılmıyor.`);
            return;
        }
        
        try {
            setLoadingHotels(prev => ({ ...prev, [code]: true }));
            console.log(`Small-data yükleniyor: ${code}`);

            const occupanciesData = (() => {
                try {
                    if (searchParams.get('occupancies')) {
                        const decodedOccupancies = JSON.parse(decodeURIComponent(searchParams.get('occupancies')));
                        return decodedOccupancies;
                    }
                } catch (error) {
                    console.error('Error parsing occupancies:', error);
                }
                return [{
                    rooms: 1,
                    adults: formParams.rooms[0].adultCounter || 2,
                    children: formParams.rooms[0].childCounter || 0,
                    paxes: formParams.rooms[0].childrenAges?.map(child => ({
                        type: "CH",
                        age: child.age === "" ? 0 : Number(child.age)
                    })) || []
                }];
            })();

            const requestParams = {
                stay: {
                    checkIn: formParams.checkIn,
                    checkOut: formParams.checkOut
                },
                occupancies: occupanciesData,
                language: "ENG",
                sourceMarket: formParams.nation ?? "ENG"
            };

            const smallData = await hotelService.getSmallData([code], requestParams);
            console.log(`Small-data yanıtı alındı: ${code}`, smallData);
            
            if (smallData && smallData.length > 0) {
                const hotelData = smallData[0];
                
                if (!hotelData.rooms || hotelData.rooms.length === 0) {
                    console.warn(`Otel ${code} için oda bilgisi bulunamadı`);
                    
                    const originalHotel = sortedHotels.find(h => h.code === code);
                    if (originalHotel && originalHotel.rooms) {
                        hotelData.rooms = originalHotel.rooms;
                    }
                } else {
                    console.log(`Otel ${code} için small-data'dan oda bilgisi alındı, ancak ilk API'den gelen odaları da koruyoruz.`);
                    const originalHotel = sortedHotels.find(h => h.code === code);
                    if (originalHotel && originalHotel.rooms) {
                        hotelData.rooms = originalHotel.rooms;
                    }
                }
                
                setLoadedHotels(prev => {
                    if (prev.includes(code)) return prev;
                    return [...prev, code];
                });
                
                if (firstHotel && firstHotel[0] && firstHotel[0].code === code) {
                    setFirstHotel(prevFirstHotel => {
                        if (!prevFirstHotel || !prevFirstHotel[0]) return prevFirstHotel;
                        
                        if (JSON.stringify(prevFirstHotel[0]) === JSON.stringify({...prevFirstHotel[0], ...hotelData})) {
                            return prevFirstHotel;
                        }
                        
                        const updatedFirstHotel = [...prevFirstHotel];
                        updatedFirstHotel[0] = {
                            ...updatedFirstHotel[0],
                            ...hotelData,
                            rooms: hotelData.rooms || updatedFirstHotel[0].rooms || [],
                            minRate: hotelData.minRate || updatedFirstHotel[0].minRate || 0,
                            images: hotelData.images || [],
                            description: hotelData.description || "",
                            categoryCode: hotelData.categoryCode || updatedFirstHotel[0].categoryCode || [],
                            city: hotelData.city || {},
                            country: hotelData.country || {},
                            segments: hotelData.segments || []
                        };
                        
                        console.log("İlk otel güncellendi:", updatedFirstHotel[0]);
                        return updatedFirstHotel;
                    });
                }
                
                setDetailedHotels(prevHotels => {
                    const hotelIndex = prevHotels.findIndex(h => h.code === code);
                    
                    if (hotelIndex !== -1) {
                        if (JSON.stringify(prevHotels[hotelIndex]) === JSON.stringify({...prevHotels[hotelIndex], ...hotelData})) {
                            return prevHotels;
                        }
                        
                        const updatedHotels = [...prevHotels];
                        updatedHotels[hotelIndex] = {
                            ...updatedHotels[hotelIndex],
                            ...hotelData,
                            rooms: hotelData.rooms || updatedHotels[hotelIndex].rooms || [],
                            minRate: hotelData.minRate || updatedHotels[hotelIndex].minRate || 0,
                            images: hotelData.images || [],
                            description: hotelData.description || "",
                            categoryCode: hotelData.categoryCode || updatedHotels[hotelIndex].categoryCode || [],
                            city: hotelData.city || {},
                            country: hotelData.country || {},
                            segments: hotelData.segments || []
                        };
                        console.log(`Otel güncellendi (${code}):`, updatedHotels[hotelIndex]);
                        return updatedHotels;
                    } else {
                        const originalHotel = sortedHotels.find(h => h.code === code);
                        if (!originalHotel) {
                            console.warn(`Otel kodu ${code} için orijinal veri bulunamadı`);
                            return prevHotels;
                        }
                        
                        const newHotel = {
                            ...originalHotel,
                            ...hotelData,
                            rooms: hotelData.rooms || originalHotel.rooms || [],
                            minRate: hotelData.minRate || originalHotel.minRate || 0,
                            images: hotelData.images || [],
                            description: hotelData.description || "",
                            categoryCode: hotelData.categoryCode || originalHotel.categoryCode || [],
                            city: hotelData.city || {},
                            country: hotelData.country || {},
                            segments: hotelData.segments || []
                        };
                        
                        const allHotels = [...prevHotels];
                        allHotels.push(newHotel);
                        
                        const sortedDetailedHotels = [];
                        
                        if (firstHotel && firstHotel[0]) {
                            const firstHotelInDetailed = allHotels.find(h => h.code === firstHotel[0].code);
                            if (firstHotelInDetailed) {
                                sortedDetailedHotels.push(firstHotelInDetailed);
                            }
                        }
                        
                        for (const hotelCode of hotelCodes) {
                            if (firstHotel && firstHotel[0] && hotelCode === firstHotel[0].code) {
                                continue;
                            }
                            
                            const hotelInDetailed = allHotels.find(h => h.code === hotelCode);
                            if (hotelInDetailed) {
                                sortedDetailedHotels.push(hotelInDetailed);
                            }
                        }
                        
                        console.log(`Yeni otel eklendi (${code}) ve liste sıralandı.`);
                        return sortedDetailedHotels;
                    }
                });
            } else {
                console.warn(`Small-data API'si ${code} için veri döndürmedi`);
            }
        } catch (error) {
            console.error(`Error loading small data for hotel ${code}:`, error);
        } finally {
            setLoadingHotels(prev => ({ ...prev, [code]: false }));
        }
    }, [formParams.nation, sortedHotels, firstHotel, loadingHotels, detailedHotels, loadedHotels, hotelCodes, formParams.checkIn, formParams.checkOut, formParams.rooms, searchParams]);

    useEffect(() => {
        if (hotelCodes.length === 0 || isLoading) return;
        
        const alreadyLoadedCodes = new Set(loadedHotels);
        
        const loadHotelsSequentially = async () => {
            const codesToLoad = hotelCodes.slice(0, 10).filter(code => !alreadyLoadedCodes.has(code) && !loadingHotels[code]);
            
            if (codesToLoad.length === 0) return;
            
            if (firstHotel && firstHotel[0] && codesToLoad.includes(firstHotel[0].code)) {
                await loadSmallData(firstHotel[0].code, 0);
                const firstHotelIndex = codesToLoad.indexOf(firstHotel[0].code);
                if (firstHotelIndex !== -1) {
                    codesToLoad.splice(firstHotelIndex, 1);
                }
            }
            
            for (const code of hotelCodes.slice(0, 10)) {
                if (firstHotel && firstHotel[0] && code === firstHotel[0].code) {
                    continue;
                }
                
                if (!codesToLoad.includes(code)) {
                    continue;
                }
                
                await loadSmallData(code);
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        };
        
        loadHotelsSequentially();
    }, [hotelCodes, loadSmallData, firstHotel, loadedHotels, isLoading, loadingHotels]);

    const sortHotelsByOption = (hotelData, sortOption) => {
        if (!hotelData || hotelData.length === 0) return [];
        
        switch (sortOption) {
            case 'price_asc':
                return [...hotelData].sort((a, b) => parseFloat(a.minRate || 0) - parseFloat(b.minRate || 0));
            case 'price_desc':
                return [...hotelData].sort((a, b) => parseFloat(b.minRate || 0) - parseFloat(a.minRate || 0));
            case 'name_asc':
                return [...hotelData].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
            case 'name_desc':
                return [...hotelData].sort((a, b) => (b.name || "").localeCompare(a.name || ""));
            case 'distance':
                return [...hotelData].sort((a, b) => (a.distance || 0) - (b.distance || 0));
            case 'recommend':
            default:
                return hotelData;
        }
    };

    const fetchData = async (params = {}) => {
        setIsLoading(true);
        setError(null);
        
        try {
            const timestamp = new Date().getTime();
            const requestData = {
                geolocation: {
                    latitude: parseFloat(formParams.lat),
                    longitude: parseFloat(formParams.lng),
                    radius: 10
                },
                page: params.page || 1,
                perPage: 10,
                sourceMarket: formParams.nation || "DE",
                checkIn: formParams.checkIn,
                checkOut: formParams.checkOut,
                occupancies: formParams.rooms.map(room => ({
                    rooms: 1,
                    adults: room.adultCounter,
                    children: room.childCounter,
                    paxes: room.childrenAges.map(child => ({
                        type: "CH",
                        age: child.age || 0
                    }))
                })),
                filter: {
                    ...(formParams.star ? { minCategory: formParams.star, maxCategory: formParams.star } : {}),
                    ...(rates.minRate ? { minRate: rates.minRate } : {}),
                    ...(rates.maxRate ? { maxRate: rates.maxRate } : {})
                },
                ...(formParams.accTypes ? { accommodations: [formParams.accTypes] } : {}),
                ...(formParams.chains ? { chains: [formParams.chains] } : {}),
                _t: timestamp,
                ...(sortOption.type !== 'default' && {
                    sortType: sortOption.type,
                    sortOrder: sortOption.column
                }),
                ...params
            };

            console.log('Fetching data with params:', requestData);
            const response = await hotelService.searchHotels(requestData);
            console.log('Search response:', response);

            let currentPage = params.page || 1;
            let retryCount = 0;
            let finalResponse = response;

            while (!finalResponse?.data?.length && retryCount < 3) {
                retryCount++;
                currentPage++;
                
                const retryRequestData = {
                    ...requestData,
                    page: currentPage
                };

                finalResponse = await hotelService.searchHotels(retryRequestData);
            }

            if (finalResponse && finalResponse.data && finalResponse.data.length > 0) {
                const rawHotels = finalResponse.data;
                console.log('Raw hotels:', rawHotels);
                const ids = rawHotels.map(h => h.id);
                setHotelIds(ids);

                const mergedHotels = await Promise.all(
                    rawHotels.map(async (hotel) => {
                        try {
                            const contentResponse = await hotelService.getHotelContent(hotel.id);
                            
                            if (contentResponse && contentResponse.code === hotel.id) {
                                return {
                                    ...hotel,
                                    name: contentResponse.name?.content || hotel.name,
                                    description: contentResponse.description?.content || '',
                                    address: contentResponse.address?.content || hotel.address,
                                    city: contentResponse.city || {
                                        content: hotel.city
                                    },
                                    country: contentResponse.country || {
                                        code: '',
                                        isoCode: '',
                                        description: {
                                            content: hotel.country
                                        }
                                    },
                                    category: contentResponse.category?.description?.content || '',
                                    accommodationType: contentResponse.accommodationType?.typeMultiDescription?.content || '',
                                    boards: contentResponse.boards || [],
                                    facilities: contentResponse.facilities || [],
                                    image: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    thumbnail: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    web: contentResponse.web || '',
                                    phones: contentResponse.phones || [],
                                    postalCode: contentResponse.postalCode || '',
                                    ranking: contentResponse.ranking || 0,
                                    wildcards: contentResponse.wildcards || []
                                };
                            }
                            return hotel;
                        } catch (err) {
                            console.error(`Error fetching content for hotel ${hotel.id}:`, err);
                            return hotel;
                        }
                    })
                );

                console.log('Merged hotels:', mergedHotels);

                if (params.page && params.page > 1) {
                    setInitialHotels(prevHotels => [...prevHotels, ...mergedHotels]);
                } else {
                    setInitialHotels(mergedHotels);
                }
                
                setPagination({
                    currentPage: params.page || 1,
                    hasMore: response.pagination?.hasMore || false,
                    totalPages: response.pagination?.totalPages || 0
                });
            } else {
                console.log('No hotels found in initial response:', response);
                setInitialHotels([]);
                setHotelIds([]);
            }
        } catch (err) {
            console.error("Error in fetchHotels:", err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewDetails = async (hotel) => {
        const urlParams = new URLSearchParams(window.location.search);
        const occupanciesStr = urlParams.get('occupancies');

        const params = new URLSearchParams();
        params.set('code', hotel.id || hotel.code); // id veya code kullan
        params.set('slug', hotel.slug || hotel.name?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
        params.set('checkIn', urlParams.get('checkIn'));
        params.set('checkOut', urlParams.get('checkOut'));
        params.set('occupancies', occupanciesStr);
        params.set('nationality', urlParams.get('nation'));

        navigate(`/hotel-detail/${params.get('code')}/${params.get('slug')}?${params.toString()}`);
        window.scrollTo(0, 0);
    };


    const fetchMoreHotels = async (currentCounter) => {
        console.log("Daha fazla otel yükleniyor, sayaç:", currentCounter);
        try {
            const start = 10 + (currentCounter - 1) * step;
            const end = start + step;
            
            const selectedCodes = hotelCodes.slice(start, end);

            if (selectedCodes.length === 0) {
                console.warn("Yüklenecek başka otel kodu yok.");
                setMoreButtonStatu(false);
                return;
            }

            for (const code of selectedCodes) {
                if (loadedHotels.includes(code) || loadingHotels[code]) {
                    continue;
                }
                
                await loadSmallData(code);
                await new Promise(resolve => setTimeout(resolve, 100));
            }

            setMoreButtonStatu(end < hotelCodes.length);
        } catch (error) {
            console.error("Veri çekerken bir hata oluştu:", error);
        } finally {
            setMoreStatu(false);
        }
    };

    const handleLoadMore = () => {
        console.log("Load more tıklandı");
        if (moreCounter < Math.ceil(hotelCodes.length / step)) {
            setMoreStatu(true);
            setMoreCounter((prevCounter) => {
                const newCounter = prevCounter + 1;
                console.log("Yeni Sayaç:", newCounter);
                fetchMoreHotels(newCounter);
                return newCounter;
            });
        } else {
            console.log("Tüm oteller yüklendi");
        }
    };

    const initializePage = async () => {
        if (isLoading) return;
        
        setIsLoading(true);
        const resetStates = () => {
            setDetailedHotels([]);
            setFirstHotel(null);
            setHotelCodes([]);
            setSortedHotels([]);
            setLoadingHotels({});
            setLoadedHotels([]);
            setMoreButtonStatu(false);
            setMoreStatu(false);
            setMoreCounter(0);
        };
        
        resetStates();
        
        try {
            const urlParams = {
                checkIn: searchParams.get('checkIn'),
                checkOut: searchParams.get('checkOut'),
                nation: searchParams.get('nation'),
                lat: searchParams.get('lat'),
                lng: searchParams.get('lng'),
                locationName: searchParams.get('locationName'),
                hotelbedsCode: searchParams.get('hotelbedsCode'),
                occupanciesStr: searchParams.get('occupancies')
            };

            const currentHotelFetchParams = {
                stay: {
                    checkIn: urlParams.checkIn,
                    checkOut: urlParams.checkOut
                },
                geolocation: {
                    latitude: urlParams.lat,
                    longitude: urlParams.lng,
                    radius: 3,
                    unit: "km"
                },
                language: "ENG",
                sourceMarket: urlParams.nation || "TR",
                occupancies: (() => {
                    try {
                        if (urlParams.occupanciesStr) {
                            return JSON.parse(decodeURIComponent(urlParams.occupanciesStr));
                        }
                    } catch (error) {
                        console.error('Error parsing occupancies:', error);
                    }
                    return [{
                        rooms: 1,
                        adults: 2,
                        children: 0,
                        paxes: []
                    }];
                })(),
                filter: {
                    minRate: 100,
                    maxRate: 5000,
                    maxRooms: 10,
                    maxRatesPerRoom: 5
                }
            };

            console.log('Initial Request Data:', currentHotelFetchParams);

            const response = await hotelService.searchHotels(currentHotelFetchParams);
            
            if (response && response.data && response.data.length > 0) {
                let sortedHotelsArray = response.data;
                
                if (urlParams.lat && urlParams.lng) {
                    sortedHotelsArray = findHotelsByDistanceAndSimilarity(
                        parseFloat(urlParams.lat),
                        parseFloat(urlParams.lng),
                        response.data,
                        urlParams.locationName
                    );
                }
                
                setSortedHotels(sortedHotelsArray);
                
                const codes = sortedHotelsArray.map(hotel => hotel.code);
                setHotelCodes(codes);

                if (urlParams.hotelbedsCode) {
                    const hotelbedsHotel = sortedHotelsArray.find(hotel => hotel.code === urlParams.hotelbedsCode);
                    if (hotelbedsHotel) {
                        setFirstHotel([{
                            ...hotelbedsHotel,
                            isLoading: true
                        }]);
                    }
                }
                
                setMoreButtonStatu(sortedHotelsArray.length > 10);
                setMoreCounter(0);
            } else {
                resetStates();
            }
        } catch (error) {
            console.error("Error in initializePage:", error);
            resetStates();
        } finally {
            setIsLoading(false);
        }
    };

    const handleClickMap = () => {
        navigate(`/hotels-with-map?${searchParams.toString()}`);
    };

    const getMarkers = (Hotels) => {
        if (!Hotels || Hotels.length === 0) return [];
        
        return Hotels.map(hotel => {
            let lat, lng;
            
            if (hotel.coordinates) {
                lat = parseFloat(hotel.coordinates.latitude);
                lng = parseFloat(hotel.coordinates.longitude);
            } else if (hotel.latitude && hotel.longitude) {
                lat = parseFloat(hotel.latitude);
                lng = parseFloat(hotel.longitude);
            } else if (hotel.lat && hotel.lng) {
                lat = parseFloat(hotel.lat);
                lng = parseFloat(hotel.lng);
            }
            
            if (isNaN(lat) || isNaN(lng)) {
                console.warn('Invalid coordinates for hotel:', hotel);
                return null;
            }

            return {
                lat: lat,
                lng: lng,
                grid_name: hotel.name?.content || hotel.name || '',
                grid_address: `${hotel.country?.description?.content || hotel.country || ''} - ${hotel.city?.content || hotel.city || ''}`,
                grid_rate: `${hotel.minRate || 0} EUR`,
                grid_day: "Night",
                grid_star: hotel.star || hotel.category?.code?.replace('EST', '') || 0,
                hotel: hotel,
                image: hotel.images?.[0]?.path || hotel.image || "https://via.placeholder.com/150",
            };
        }).filter(marker => marker !== null);
    };

    useEffect(() => {
        if (initialHotels && initialHotels.length > 0) {
            console.log('Setting markers from initialHotels:', initialHotels);
            const newMarkers = getMarkers(initialHotels);
            console.log('Generated markers:', newMarkers);
            setMarkers(newMarkers);
        }
    }, [initialHotels]);

    const currentMarkers = useMemo(() => {
        console.log('Calculating currentMarkers from markers:', markers);
        return markers;
    }, [markers]);

    const GoogleMap = () => {
        const [center, setCenter] = useState({
            lat: currentMarkers[0]?.lat || 41.0082,
            lng: currentMarkers[0]?.lng || 28.9784
        });
        const infoWindowsRef = useRef([]);

        useEffect(() => {
            if (!isMapLoaded || !currentMarkers.length) {
                console.log('Map not loaded or no markers:', { isMapLoaded, markersCount: currentMarkers.length });
                return;
            }

            console.log('Initializing map with markers:', currentMarkers);

            const map = new window.google.maps.Map(document.getElementById("map"), {
                center: center,
                zoom: 13,
                mapTypeId: 'roadmap'
            });

            mapRef.current = map;

            // Önceki infoWindows'ları temizle
            infoWindowsRef.current.forEach(infoWindow => {
                infoWindow.close();
            });
            infoWindowsRef.current = [];

            currentMarkers.forEach((marker, index) => {
                if (!marker.lat || !marker.lng) {
                    console.warn('Invalid marker coordinates:', marker);
                    return;
                }

                const googleMarker = new window.google.maps.Marker({
                    position: { lat: marker.lat, lng: marker.lng },
                    map: map,
                    title: marker.grid_name,
                    icon: {
                        url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
                    }
                });

                const infoWindow = new window.google.maps.InfoWindow();
                infoWindowsRef.current.push(infoWindow);

                const contentDiv = document.createElement("div");
                const root = ReactDOM.createRoot(contentDiv);
                
                root.render(
                    <div className="card" style={{ width: '250px' }}>
                        <div className="card-img">
                            <img
                                className="img-fluid w-100"
                                style={{ height: "150px", objectFit: "cover" }}
                                alt="img"
                                src={marker.image}
                            />
                        </div>
                        <div className="card-body">
                            <h5 className="title mb-2">
                                <a
                                    onClick={() => handleViewDetails(marker.hotel)}
                                    style={{ cursor: 'pointer', color: '#007bff' }}
                                >
                                    {marker.grid_name}
                                </a>
                            </h5>
                            <p className="mb-3">
                                <i className="isax isax-location"></i> {marker.grid_address}
                            </p>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <h6 className="text-primary border-end pe-2 me-2">
                                        {marker.grid_rate}
                                    </h6>
                                    <p>{marker.grid_day}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                );

                infoWindow.setContent(contentDiv);

                googleMarker.addListener("click", () => {
                    // Diğer tüm infoWindows'ları kapat
                    infoWindowsRef.current.forEach(iw => {
                        if (iw !== infoWindow) {
                            iw.close();
                        }
                    });
                    infoWindow.open(map, googleMarker);
                });

                if (index === 0) {
                    infoWindow.open(map, googleMarker);
                }
            });

            // Harita merkezi değiştiğinde state'i güncelle
            const centerChangedListener = map.addListener("center_changed", () => {
                const newCenter = map.getCenter();
                setCenter({
                    lat: newCenter.lat(),
                    lng: newCenter.lng(),
                });
            });

            // Cleanup function
            return () => {
                // Event listener'ı temizle
                window.google.maps.event.removeListener(centerChangedListener);
                // InfoWindows'ları temizle
                infoWindowsRef.current.forEach(infoWindow => {
                    infoWindow.close();
                });
                infoWindowsRef.current = [];
            };
        }, [currentMarkers, isMapLoaded]); // center'ı dependency'den çıkardık

        return <div id="map" style={{ height: "100%", width: "100%" }} />;
    };

    const [isFixed, setIsFixed] = useState(false);
    const [height, setHeight] = useState('90%');

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const scrollHeight = document.documentElement.scrollHeight;
            const windowHeight = window.innerHeight;
            
            if (scrollY >= 330 && scrollY <= scrollHeight - windowHeight - 450) {
                setIsFixed(true);
                setHeight(`${windowHeight}px`);
            } else {
                setIsFixed(false);
                setHeight('95%');
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleViewHotels = () => {
        // Haritanın o anki merkez noktasını al
        const map = mapRef.current;
        if (!map) {
            console.warn('Map is not initialized yet');
            return;
        }

        const currentCenter = map.getCenter();
        const currentLat = currentCenter.lat();
        const currentLng = currentCenter.lng();
        
        const params = new URLSearchParams();
        params.set('checkIn', formParams.checkIn);
        params.set('checkOut', formParams.checkOut);
        params.set('nation', localStorage.getItem("nation") ?? "TR");
        params.set('lat', currentLat);
        params.set('lng', currentLng);
        
        if (selectedLocation.hotel_code) {
            params.set('hotelbedsCode', selectedLocation.hotel_code);
        }
        params.set('locationName', selectedLocation.name || selectedPlace?.name || localStorage.getItem("place_name"));

        const occupancies = formParams.rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age || ""
            }))
        }));
        params.set('occupancies', JSON.stringify(occupancies));

        navigate(`/hotels-with-map?${params.toString()}`);
        window.scrollTo(0, 0);
        
        const requestData = {
            stay: {
                checkIn: formParams.checkIn,
                checkOut: formParams.checkOut
            },
            geolocation: {
                latitude: currentLat,
                longitude: currentLng,
                radius: 10,
                unit: "km"
            },
            language: "ENG",
            sourceMarket: formParams.nation || "TR",
            occupancies: formParams.rooms.map(room => ({
                rooms: 1,
                adults: room.adultCounter,
                children: room.childCounter,
                paxes: room.childrenAges.map(child => ({
                    type: "CH",
                    age: child.age || ""
                }))
            })),
        };

        fetchData(requestData);
    };

    const handleListView = () => {
        navigate(`/hotels?${searchParams.toString()}`);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        if (formParams.lat && formParams.lng) {
            setInitialHotels([]);
            setHotelIds([]);
            fetchData();
        }
    }, [formParams.lat, formParams.lng, formParams.checkIn, formParams.checkOut, formParams.rooms, formParams.nation, formParams.star, formParams.accTypes, formParams.chains, rates, sortOption]);

    return (
        <Layout>
            <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2">Hotels</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item"><a href="index.html"><i className="isax isax-home5"></i></a></li>
                                    <li className="breadcrumb-item">Hotels</li>
                                    <li className="breadcrumb-item active" aria-current="page">Hotel Grid Lists</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">
                    <div className="card" style={{ position: 'relative', zIndex: 1000 }}>
                        <div className="card-body">
                            <div className="banner-form" style={{ position: 'relative', zIndex: 1001 }}>
                                <SearchForm onSubmit={fetchData} />
                            </div>
                        </div>
                    </div>


                    <button className="btn btn-link p-0 text-primary mb-3" onClick={() => handleListView()}>
                        Click for list view
                    </button>
                    

                    <div className="row">
                        <div className="col-12">
                            {isLoading ? (
                                <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: 'calc(100vh - 200px)' }}>
                                    <img src="/assets/gif/loading.gif" alt="Loading" style={{ width: "80px", height: "80px" }} />
                                    <p className="mt-3 mb-0">Loading Hotels...</p>
                                </div>
                            ) : error ? (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            ) : initialHotels.length > 0 ? (
                                <div style={{ 
                                    height: 'calc(100vh - 200px)', 
                                    position: 'relative' 
                                }}>
                                    <button
                                        style={{
                                            position: "absolute",
                                            top: "20px",
                                            left: "50%",
                                            transform: "translateX(-50%)", 
                                            padding: "10px 20px",
                                            fontSize: "16px",
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            cursor: "pointer",
                                            zIndex: 1000,
                                        }}
                                        onClick={() => handleViewHotels()}
                                    >
                                        View Hotels
                                    </button>
                                    {isMapLoaded ? (
                                        <GoogleMapsLoader apiKey={config.API_KEY}>
                                            <GoogleMap />
                                        </GoogleMapsLoader>
                                    ) : (
                                        <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '100%' }}>
                                            <img src="/assets/gif/loading.gif" alt="Loading" style={{ width: "80px", height: "80px" }} />
                                            <p className="mt-3 mb-0">Loading Map...</p>
                                        </div>
                                    )}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            
            <Modal
                show={selectedRate !== null}
                onHide={() => setSelectedRate(null)}
                centered
                backdropClassName="custom-backdrop"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Cancellation Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRate?.cancellationPolicies?.map((policy, index) => (
                        <div key={index} className="d-flex flex-column" style={{ minWidth: "200px" }}>
                            <p
                                className="d-inline-flex align-items-center mb-2 me-2 gap-1"
                                style={{ color: "black", textAlign: "center", fontSize: "13px" }}
                            >
                                {
                                    Number(selectedRate?.cancellationPolicies?.[0]?.amount).toFixed(2) === Number(selectedRate.net).toFixed(2) ?
                                        <>
                                            <div className="d-flex flex-row align-items-center gap-2">
                                                <TiTick style={{ color: "green", fontSize: "20px" }} />
                                                <p className="mb-0 text-black">Free Cancellation until {new Intl.DateTimeFormat("en-US", {
                                                    dateStyle: "medium",
                                                    timeStyle: "short",
                                                }).format(new Date(selectedRate?.cancellationPolicies?.[0]?.from))}</p>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <span>You can cancel until </span>
                                            <span style={{ color: "red" }}>
                                                {new Intl.DateTimeFormat("en-US", {
                                                    dateStyle: "medium",
                                                    timeStyle: "short",
                                                }).format(new Date(policy.from))}
                                            </span>
                                            
                                            <span> for </span>
                                            <span style={{ color: "red" }}>
                                                ${Number(policy.amount).toFixed(2)}
                                            </span>
                                        </>
                                }
                            </p>
                        </div>
                    ))}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setSelectedRate(null)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Layout>
    )
}
